import axios from "axios";
import {provider} from "../service/provider";
import mainMixin from "./mainMixin";
import math from "math"

export default {
    name: "OptionDataMixin",
    mixins: [mainMixin],
    data() {
        return {
            listProductOutsideEco: [],
            supplierOptionList: [],
            listWalkinMember: [],
            clientOptionList: [],
            listClient: [],
            productBySupplierList: [],
            categoryOptionList: [],
            currencyOptionList: [],
            farmerOptionList: [],
            productList: [],
            productListSetting: [],
            productRegistration: [],
            listProductCheckIn:[],
            listBuyBackInvoice: [],
            listBuyBackReport: [],
            listProductByCategory: [],
            transactionOrderList: [],
            transactionProductOrderList: [],
            transactionDeliveriesList: [],
            transactionList: [],
            dueTransactionPaymentTermList: [],
            transactionPaymentList: [],
            transactionContactPaymentTerm: [],
            listTransactionPaymentTerm: [],
            listIncentives: [],
            customerWallet: [],
            listUnits: [],
            listCategories: [], 
            parentCategories:[],
            childCategories:[],
            grandChildCategories:[],
            durationPeriodList: ['per_day', 'per_week', 'per_month'],
            steps: [1, 2, 3, 4, 5],
            stockTransferList: [],
            stockReconcileList: [],
            stockList: [],
            supplierTransferOptionList: [],
            clientTransferOptionListByEmployee:[],
            clientTransferOptionList:[],
            listMiller: [],
            listMillerAndExporter: [],
            listCropTrader: [],
            paymentListReport: [],
            listMemberProduct: [],
            listRequestDrawdown: [],
            listInvoiceFinanceRequestDrawdown: [],
            listCropCollectPlaning: [],
            listDraftInvoice: [],
            invoiceType: [],
            listBill: [],
            listInvoice: [],
            listPaymentVourcher: [],
            listReceiptVourcher: [],
            listRevolvingCredit: [],
            listTransactionReconcileInvoice: [],
            listContactPersonal:[],
            listPaymentReport:[],
            listStockBalanceReport:[],
            listSaleTransactionReport:[],
        };
    },
    methods: {

        convertExchangeRate(from, to, amount) {
            let khrRateDoc = this.currencyOptionList.find(o => o.id === "KHR");
            let thbRateDoc = this.currencyOptionList.find(o => o.id === "THB");
            //to USD
            let newAmount = 0;
            amount = parseFloat(amount);
            let khrRate = parseFloat(khrRateDoc && khrRateDoc.rate || 0);
            let thbRate = parseFloat(thbRateDoc && thbRateDoc.rate || 0);

            if (from === "USD") {
                switch (to) {
                    case "KHR":
                        newAmount = amount * khrRate;
                        break;
                    case "THB":
                        newAmount = amount * thbRate;
                        break;
                    default:
                        newAmount = amount;
                        break;
                }
                return parseFloat(math.round(newAmount, 3));
            } else if (from === "KHR") {
                switch (to) {
                    case "USD":
                        newAmount = amount / khrRate;
                        break;
                    case "THB":
                        newAmount = (amount / khrRate) * thbRate;
                        break;
                    default:
                        newAmount = amount;
                        break;
                }
                return parseFloat(math.round(newAmount, 3));

            } else if (from === "THB") {
                switch (to) {
                    case "USD":
                        newAmount = amount / thbRate;
                        break;
                    case "KHR":
                        newAmount = (amount / thbRate) * khrRate;
                        break;
                    default:
                        newAmount = amount;
                        break;
                }
                return parseFloat(math.round(newAmount, 3));
            } else {
                return parseFloat(newAmount);
            }

        },
       
        fetchListBuyBackInvoice({search, sortBy, sortDesc, offset, limit, reference, from_date, to_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.fetchListBuyBackInvoice;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    reference   : reference || "",
                    search      : search || '',
                    id          : "",
                    offset      : offset - 1,
                    sort_by     : sortBy || "created_at",
                    sort_desc   : sortDesc === false ? 0 : 1,
                    limit       : limit || vm.itemsPerPage,
                    from_date   : from_date,
                    to_date     : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listBuyBackInvoice   = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },
       
        fetchListRequestDrawdown({search, sortBy, sortDesc, offset, limit, id, crop_trader_id, application_no, from_date, to_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.fetchListRequestDrawdown;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search          : search || "",
                    id              : id || "",
                    crop_trader_id  : crop_trader_id || "",
                    application_no  : application_no || "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listRequestDrawdown   = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListInvoiceFinanceRequestDrawdown({search, sortBy, sortDesc, offset, limit, id, crop_trader_id, application_no, from_date, to_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.fetchListInvoiceFinanceRequestDrawdown;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search          : search || "",
                    id              : id || "",
                    crop_trader_id  : crop_trader_id || "",
                    application_no  : application_no || "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listInvoiceFinanceRequestDrawdown   = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListCropCollectPlaning({search, sortBy, sortDesc, offset, limit, id, from_date, to_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.fetchListCropCollectPlaning;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search          : search || "",
                    id              : id || "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listCropCollectPlaning   = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListBill({search, sortBy, sortDesc, offset, limit, id, from_date, to_date, type_order, contact_id}) {
            let vm      = this;
            let url     = provider.baseURL + provider.fetchListBill;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search          : search || "",
                    type_order      : type_order || "",
                    contact_id      : contact_id || "",
                    id              : id || "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listBill             = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListInvoice({search, sortBy, sortDesc, offset, limit, id, from_date, to_date, type_order, contact_id}) {
            let vm      = this;
            let url     = provider.baseURL + provider.fetchListInvoice;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search          : search || "",
                    type_order      : type_order || "",
                    contact_id      : contact_id || "",
                    id              : id || "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listInvoice          = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListDraftInvoice({search, sortBy, sortDesc, offset, limit, id, from_date, to_date, contact_id, type_order}) {
            let vm      = this;
            let url     = provider.baseURL + provider.fetchListDraftInvoice;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    contact_id      : contact_id || "",
                    type_order      : type_order || "",
                    search          : search || "",
                    id              : id || "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listDraftInvoice     = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListReceiptVourcher({search, sortBy, sortDesc, offset, limit, id, from_date, to_date, type_order, contact_id, transaction_id}) {
            let vm      = this;
            let url     = provider.baseURL + provider.fetchListReceiptVourcher;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search          : search || "",
                    transaction_id  : transaction_id || "",
                    type_order      : type_order || "",
                    contact_id      : contact_id || "",
                    id              : id || "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listReceiptVourcher  = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListRevolvingCredit({id, search, from_date, to_date, crop_trader_id, application_no, offset, limit}) {
            let vm      = this;
            let url     = provider.baseURL + provider.fetchListRevolvingCredit;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search          : search || "",
                    crop_trader_id  : crop_trader_id || "",
                    application_no  : application_no || "",
                    id              : id || "",
                    offset          : offset - 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listRevolvingCredit  = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListTransactionReconcileInvoice({search, sortBy, sortDesc, offset, limit, contact_id, from_date, to_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getTransactionReconcileInvoice;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search          : search || '',
                    contact_id      : contact_id || '',
                    id              : "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date || '',
                    to_date         : to_date || ''
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listTransactionReconcileInvoice = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListBuyBackReport({search, sortBy, sortDesc, offset, limit, reference, date_from, date_to, id, status}) {
            let vm      = this;
            let url     = provider.baseURL + provider.fetchListBuyBackReport;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    status          : status || "",
                    id              : id || "",
                    search          : search || "",
                    reference       : reference || "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    date_from       : date_from,
                    date_to         : date_to
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listBuyBackReport    = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchTransactionOrder({search, sortBy, sortDesc, offset, limit, status, typeOrder, from_date, to_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getTransactionOrder;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : search || '',
                    id          : "",
                    status      : status || "",
                    type_order  : typeOrder || "",
                    offset      : offset - 1,
                    sort_by     : sortBy || "created_at",
                    sort_desc   : sortDesc === false ? 0 : 1,
                    limit       : limit || vm.itemsPerPage,
                    from_date   : from_date,
                    to_date     : to_date,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.transactionOrderList = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchTransactionProductOrder({search, sortBy, sortDesc, offset, limit, status, from_date, to_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getListTransactionProductOrder;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : search || '',
                    id          : "",
                    status      : status || "",
                    product_type: "",
                    offset      : offset - 1,
                    sort_by     : sortBy || "created_at",
                    sort_desc   : sortDesc === false ? 0 : 1,
                    limit       : limit || vm.itemsPerPage,
                    from_date   : from_date,
                    to_date     : to_date,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.transactionProductOrderList  = res.data.data;
                            vm.totalPage                    = parseInt(res.data.row_count);
                            vm.pageCount                    = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage                  = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading                      = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchTransactionDeliveries({search, sortBy, sortDesc, offset, limit, type, status, from_date, to_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getTransactionDeliveryNote;
            vm.transactionDeliveriesList = [];
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : search || '',
                    id          : "",
                    contact_id  : "",
                    offset      : offset - 1,
                    sort_by     : sortBy || "created_at",
                    sort_desc   : sortDesc === false ? 0 : 1,
                    limit       : limit || vm.itemsPerPage,
                    type        : type || "",
                    status      : status || "",
                    from_date   : from_date,
                    to_date     : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.transactionDeliveriesList = res.data.data;
                            vm.totalPage                 = parseInt(res.data.row_count);
                            vm.pageCount                 = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage               = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading                   = false;
                        }
                    },
                    error => { reject(error); }
                );
            });

        },

        fetchDueTransactionPaymentTerm({ status, search, sortBy, sortDesc, offset, limit, transaction_id, contact_id, type_order, due_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getDueTransactionPaymentTerm;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    status          : status || "",
                    search          : search || "",
                    transaction_id  : transaction_id || '',
                    type_order      : type_order || "",
                    contact_id      : contact_id || "",
                    due_date        : due_date || '',
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data);
                            vm.dueTransactionPaymentTermList = res.data.data;
                            vm.totalPage = parseInt(res.data.row_count);
                            vm.pageCount = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchTransactionProductTakeOut({search, sortBy, sortDesc, offset, limit, from_date, to_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getListTransactionProductTakeOut;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : search || '',
                    id          : "",
                    reference   : "",
                    offset      : offset - 1,
                    sort_by     : sortBy || "created_at",
                    sort_desc   : sortDesc === false ? 0 : 1,
                    limit       : limit || vm.itemsPerPage,
                    from_date   : from_date,
                    to_date     : to_date,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.transactionList  = res.data.data;
                            vm.totalPage        = parseInt(res.data.row_count);
                            vm.pageCount        = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage      = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading          = false;
                        }
                    },
                    error => { reject(error); }
                );
            });

        },

        fetchTransactionPayment({search, sortBy, sortDesc, offset, limit, contact_id, type_order, transaction_type, from_date, to_date, tran_type}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getTransactionPayment;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    transaction_type: transaction_type || '',
                    contact_id      : contact_id || '',
                    type_order      : type_order || '',
                    search          : search || '',
                    tran_type       : tran_type || '',
                    id              : "",
                    transaction_id  : "",
                    reference       : "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.transactionPaymentList   = res.data.data;
                            vm.totalPage                = parseInt(res.data.row_count);
                            vm.pageCount                = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage              = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading                  = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchTransferTransactionPayment({search, sortBy, sortDesc, offset, limit, contact_id, type_order, transaction_id, id, from_date, to_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getListTransactionPayment;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    transaction_id  : transaction_id || '',
                    contact_id      : contact_id || '',
                    type_order      : type_order || '',
                    search          : search || '',
                    id              : id || "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listTransactionPaymentTerm   = res.data.row_count ? res.data.data : [];
                            vm.totalPage                    = parseInt(res.data.row_count);
                            vm.pageCount                    = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage                  = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading                      = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchPaymentListReport({search, sortBy, sortDesc, offset, limit, from_date, to_date, type}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getListPaymentReport;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search          : search || '',
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date,
                    type            : type || ''
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.paymentListReport            = res.data.row_count ? res.data.data : [];
                            vm.totalPage                    = parseInt(res.data.row_count);
                            vm.pageCount                    = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage                  = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading                      = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchTransaction({search, sortBy, sortDesc, offset, limit, type_order, contact_id, from_date, to_date, tran_type}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getTransaction;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : search || '',
                    id          : "",
                    contact_id  : contact_id || "",
                    offset      : offset - 1,
                    sort_by     : sortBy || "created_at",
                    sort_desc   : sortDesc === false ? 0 : 1,
                    type_order  : type_order || "sale_order",
                    limit       : limit || vm.itemsPerPage,
                    from_date   : from_date,
                    to_date     : to_date,
                    tran_type   : tran_type || '',
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.transactionList  = res.data.data;
                            vm.totalPage        = parseInt(res.data.row_count);
                            vm.pageCount        = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage      = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading          = false;
                        }
                    },
                    error => { reject(error); }
                );
            });

        },

        fetchStockReconcileList({search, sortBy, sortDesc, offset, limit, eco_business}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getStockReconcileList;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : search || '',
                    id          : "",
                    offset      : offset - 1,
                    sort_by     : sortBy || "created_at",
                    sort_desc   : sortDesc === false ? 0 : 1,
                    eco_business: eco_business || '',
                    limit       : limit || vm.itemsPerPage
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.stockReconcileList   = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });

        },

        fetchStockList({member_id, eco_business, offset, limit}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getStockList;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    member_id   : member_id || '',
                    eco_business: eco_business || '',
                    offset      : offset - 1,
                    limit       : limit || vm.itemsPerPage

                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.stockList    = res.data.data;
                            vm.totalPage    = parseInt(res.data.row_count);
                            vm.pageCount    = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage  = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading      = false;
                        }   
                    },
                    error => { reject(error); }
                );
            });

        },

        fetchStockTransfer({transfer_status, search, sortBy, sortDesc, offset, limit, id, from_date, to_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getStockTransfer;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    transfer_status : transfer_status || "",
                    search          : search || '',
                    id              : id || "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.stockTransferList    = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        // ========= Selection Option ==========
        fetchFarmerOption(val) {
            let vm = this;
            let url = provider.baseURL + provider.getListFarmer;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : val || "",
                    parent_id   : "",
                    offset      : 0,
                    limit       : vm.noLimit,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.farmerOptionList = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchSupplierOption(val, type, parent_id) {
            let vm  = this;
            let url = provider.baseURL + provider.getListSupplier;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : val || "",
                    parent_id   : type === "beeDepo" ? "" : parent_id,
                    client_type : type || "",
                    id          : "",
                    offset      : 0,
                    limit       : vm.noLimit,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.supplierOptionList = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListWalkinMember(type) {
            let vm = this;
            let url = provider.baseURL + provider.getlistWalkinMember;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search: "",
                    id:  "",
                    type: type,
                    offset: 0,
                    limit: 200,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listWalkinMember = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        },

        fetchClientTransferByUserTypeOptionByEmployee(val, type) {
            let vm = this;
            let url = provider.baseURL + provider.listSupplierTransferByUserType;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : val || "",
                    id          : "",
                    offset      : 0,
                    user_type   : type || "",
                    limit       : vm.noLimit,
                    sort_by     : "created_at",
                    sort_desc   : 1,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            let data = res.data.data;
                            data = res.data.data.filter(arrs => {
                                return arrs.type == 'beeXPress' || arrs.type == 'beeShop' || arrs.type == 'beeDepo';
                               
                            });
                            vm.clientTransferOptionListByEmployee = data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchClientTransferByUserTypeOption(val, type) {
            let vm = this;
            let url = provider.baseURL + provider.listSupplierTransferByUserType;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : val || "",
                    id          : "",
                    offset      : 0,
                    user_type   : type || "",
                    limit       : vm.noLimit,
                    sort_by     : "created_at",
                    sort_desc   : 1,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.clientTransferOptionList = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListMiller() {
            let vm  = this;
            let url = provider.baseURL + provider.getListMiller;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    offset: 0,
                    limit: vm.noLimit,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data);
                            vm.listMiller = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListMillerAndExporter() {
            let vm  = this;
            let url = provider.baseURL + provider.getListMillerAndExporter;
            return new Promise((resolve, reject) => {
                axios.post(url, {
                    offset: 0,
                    limit: vm.noLimit,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data);
                            vm.listMillerAndExporter = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListCropTrader() {
            let vm = this;
            let url = provider.baseURL + provider.getListCropTrader;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    offset: 0,
                    limit: vm.noLimit,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data);
                            vm.listCropTrader = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchClientOption(val) {
            let vm = this;
            let url = provider.baseURL + provider.getListSupplier;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : val || "",
                    parent_id   : "",
                    client_type : "",
                    id          : "",
                    offset      : 0,
                    limit       : vm.noLimit,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data);
                            vm.clientOptionList = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchCategoryOption(supplier_id, transaction_type, type) {
            let vm  = this;
            let url = provider.baseURL + provider.getCategory;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    type            : type || [],
                    supplier_id     : supplier_id || "",
                    transaction_type: transaction_type || ""
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.categoryOptionList = res.data.data;
                        }
                    },
                    error => { reject(error);}
                );
            });
        },

        fetchParentCategory(){
            let vm  = this;
            let url = provider.baseURL + provider.getListCategory;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    product_type: '',
                    search      : '',
                    id          : "",
                    offset      : 0,
                    sort_by     : "created_at",
                    sort_desc   : 1,
                    limit       : vm.noLimit
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.parentCategories = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchChildCategory({productType}){
            let vm  = this;
            let url = provider.baseURL + provider.getListCategory;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    product_type: productType || '',
                    search      : '',
                    id          : "",
                    offset      : 0,
                    sort_by     : "created_at",
                    sort_desc   : 1,
                    limit       : vm.noLimit
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.childCategories = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchGrandChildCategory({productType, parent_id}){
            let vm  = this;
            let url = provider.baseURL + provider.getListCategory;
            return new Promise((resolve, reject) => {
                axios.post(url, {
                    product_type    : productType || '',
                    parent_id       : parent_id || '',
                    search          : '',
                    id              : "",
                    offset          : 0,
                    sort_by         : "created_at",
                    sort_desc       : 1,
                    limit           : vm.noLimit
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.grandChildCategories = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchCurrencyOption() {
            let vm  = this;
            let url = provider.baseURL + provider.getCurrency;

            return new Promise((resolve, reject) => {
                axios.post(url, {currency_id: ""}, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.currencyOptionList = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchProduct(val, category_id, supplierId, currency_code, type, client_type) {
            let vm  = this;
            let url = provider.baseURL + provider.getListProduct;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    contact_id: supplierId || "",
                    category_id: category_id || "",
                    type: type || "",
                    search: val || "",
                    currency_code: currency_code || '',
                    client_type: client_type || "",
                    offset: 0,
                    limit: vm.noLimit
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data);
                            vm.productList = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },
        // ============ End Selection Option =========== 

        fetchProductSetting({id, category_id, search, sortBy, sortDesc, offset, limit}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getListProductSetting;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    id              : id || "",
                    category_id     : category_id || "",
                    search          : search || "",
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    offset          : offset - 1,
                    limit           : limit || vm.itemsPerPage
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data);
                            vm.productListSetting   = res.data.data;
                            vm.totalPage            = parseInt(res.data.data.length);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        },

        fetchProductRegistration({id, contact_id, currency_code, category_id, search, limit, offset}) {
            let vm = this;
            let url = provider.baseURL + provider.getProductRegistration;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    id              : id || '', 
                    contact_id      : contact_id || '', 
                    currency_code   : currency_code || '', 
                    category_id     : category_id || '', 
                    search          : search || '', 
                    offset          : offset - 1,
                    limit           : limit || vm.itemsPerPage, 
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.productRegistration  = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListProdctOutsideEco({contact_id, currency_code, category_id, search, limit, offset, client_type, type}) {
            let vm  = this;
            let url = provider.baseURL + provider.listProductOutsideEco;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    contact_id      : contact_id || '', 
                    currency_code   : currency_code || '', 
                    category_id     : category_id || '', 
                    client_type     : client_type || '', 
                    type            : type || '', 
                    search          : search || '', 
                    limit           : limit || vm.itemsPerPage, 
                    offset          : offset - 1
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listProductOutsideEco    = res.data.data;
                            vm.totalPage                = parseInt(res.data.data.length);
                            vm.pageCount                = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage              = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading                  = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchProductCheckInOut({id, reference, type, search, limit, offset, from_date, to_date}) {
            let vm      = this;
            let url     = provider.baseURL + provider.listProductCheckInOut;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    id              : id || '', 
                    reference       : reference || '', 
                    type            : type || '', 
                    search          : search || '', 
                    limit           : limit || vm.itemsPerPage,
                    offset          : offset - 1,
                    from_date       : from_date,
                    to_date         : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listProductCheckIn   = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchProductByCategory(category_id, token = '') {
            let vm = this;
            let url = provider.baseURL + provider.getListProductByCategory;

            return new Promise((resolve, reject) => {
                axios.post(
                    url, 
                    {category_id: category_id || ""},
                    {headers: {Authorization: token ? token : localStorage.token }}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data);
                            vm.listProductByCategory = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchProductBySupplierId(params = {}) {
            let vm = this;
            let url= provider.baseURL + provider.getListStockBySupplierId;

            return new Promise((resolve, reject) => {
                axios.post(url, params, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data);
                            vm.productBySupplierList = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchProductPackage(val, category_id, payment_method, currency_code) {
            let vm = this;
            let url = provider.baseURL + provider.getListProductPackage;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    category_id     : category_id || "",
                    search          : val || "",
                    payment_method  : payment_method || "",
                    province_code   : localStorage.province_code || "",
                    currency_code   : currency_code || "",
                    offset          : vm.currentPage - 1,
                    limit           : vm.noLimit
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data);
                            vm.productList = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        },

        fetchProductFarmer(val, category_id, supplierId, currency_code, type, payment_method) {
            let vm  = this;
            let url = provider.baseURL + provider.getListProductFarmer;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    contact_id      : supplierId,
                    category_id     : category_id || "",
                    type            : ["agri-input", "rice"],
                    search          : val || "",
                    currency_code   : currency_code || '',
                    payment_method  : payment_method || '',
                    offset          : vm.currentPage - 1,
                    limit           : vm.noLimit
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data);
                            vm.productList = res.data.data;
                        }
                    },
                    error => { reject(error); }
                );
            });

        },

        fetchWalletByCustomer(account_no, currency_code, user_type = '') {
            let vm = this;
            let tokenUrl = provider.walletURL + provider.token;
            let username = localStorage.phone;
            let password = vm.my_decrypt(localStorage.password);
            
            if(localStorage.type == 'employee'){
                username = 'beeshop'
                password = 'beeShopBEEs6rp'
            }

            return new Promise((resolve, reject) => {
                axios.post(tokenUrl, {
                    username,
                    password
                }).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            let url = provider.walletURL + provider.getListWalletCustomerType;
                            return new Promise((resolve, reject) => {
                                axios.post(url, {
                                    account_no,
                                    currency_code,
                                    user_type
                                }, {headers: {Authorization: res.data.token}}).then(
                                    response => {
                                        if (response.data.response && response.data.response.code === 200) {
                                            resolve(response.data);
                                            vm.customerWallet = response.data.data && response.data.data.list_customer_type[0] && response.data.data.list_customer_type[0].savings_account_type || [];
                                        }
                                    },
                                    error => { reject(error); }
                                );
                            });
                        }
                    },
                    error => { reject(error); }
                );
            });


        },

        fetchTransactionUnit({search, sortBy, sortDesc, offset, limit}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getListUnit;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : search,
                    id          : "",
                    offset      : offset - 1,
                    sort_by     : sortBy || "created_at",
                    sort_desc   : sortDesc === false ? 0 : 1,
                    limit       : limit || vm.itemsPerPage
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listUnits    = res.data.data;
                            vm.totalPage    = parseInt(res.data.row);
                            vm.pageCount    = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage  = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading      = false;
                        }
                    },
                    error => { reject(error); } 
                );
            });
        },

        fetchTransactionIncentive({search, sortBy, sortDesc, offset, limit}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getListIncentive;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search      : search || '',
                    id          : "",
                    offset      : offset - 1,
                    sort_by     : sortBy || "created_at",
                    sort_desc   : sortDesc === false ? 0 : 1,
                    limit       : limit || vm.itemsPerPage
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listIncentives   = res.data.data;
                            vm.totalPage        = parseInt(res.data.row);
                            vm.pageCount        = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage      = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading = false;
                        }
                    },
                    error => { reject(error);}
                );
            });

        },

        fetchTransactionCategory({productType, search, sortBy, sortDesc, offset, limit}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getListCategory;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    product_type    : productType || "",
                    search          : search || '',
                    id              : "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listCategories   = res.data.data;
                            vm.totalPage        = parseInt(res.data.row_count);
                            vm.pageCount        = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage      = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading          = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchContactPaymentTerm() {
            // fetchContactPaymentTerm({search, sortBy, sortDesc, offset, limit, status, typeOrder}) {
            let vm = this;
            vm.loading = true;
            // let url = provider.baseURL + provider.getTransactionCategory;

            let res = {
                data: {
                    data: [
                        {
                            id: 1,
                            contact_name: 'Gift Ahh',
                            contact_id: 4,
                            step: 1,
                            duration: 0,
                            duration_type: 'per_day',
                            percentage: 30,
                            status: 'active',
                            description: 'Welcome to bigsoft'
                        },
                        {
                            id: 2,
                            contact_name: 'Gift Ahh',
                            contact_id: 4,
                            step: 2,
                            duration: 0,
                            duration_type: 'per_week',
                            percentage: 50,
                            status: 'inactive',
                            description: 'Welcome to bigsoft'
                        },

                    ],
                    response: {
                        code: 200,
                        message: 'Get Contact payment term successful'
                    },
                    row_count: 2
                }
            }

            vm.transactionContactPaymentTerm = res.data.data;
            vm.totalPage = parseInt(res.data.row_count);
            vm.pageCount = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
            vm.currentPage = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
            vm.loading = false;
        },

        fetchBusinessSetting() {
            // let vm = this;
            // vm.loading = true;
            let url = provider.baseURL + provider.getBusinessSetting;


            return new Promise((resolve, reject) => {
                axios.post(url, {}, 
                    {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            console.log(res.data);
                            resolve(res.data.data);
                            // vm.listCategories = res.data.data;
                            // vm.totalPage = parseInt(res.data.row_count);
                            // vm.pageCount = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            // vm.currentPage = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            // vm.loading = false;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        },

        fetchContactOptionRep(token) {
            let vm = this;
            let url = provider.baseURL + provider.fetchListContactOpt;
            return new Promise((resolve, reject) => {
                axios.post(url, {user_type: localStorage.type || ""}, {headers: {Authorization: token }}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listClient = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });

        },

        fetchMemberProduct() {
            let vm      = this;
            let url     = provider.baseURL + provider.fetchMemberList;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    offset          : 0,
                    limit           : 10000
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listMemberProduct   = res.data.data;
                            vm.loading          = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListInvoiceType(type) {
            let vm = this;
            let url = type ? provider.fetchListFinalInvoiceType : provider.fetchListInvoiceType;
            url     = provider.baseURL + url;
            return new Promise((resolve, reject) => {
                axios.post(url, {}, {headers: {Authorization: localStorage.token }}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.invoiceType = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        },

        fetchListContactPersonal({player, search, sortBy, sortDesc, offset, limit}) {
            let vm      = this;
            let url     = provider.baseURL + provider.getListContactPersonal;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    player          : player || "",
                    search          : search || '',
                    id              : "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listContactPersonal = res.data.data;
                            vm.totalPage           = parseInt(res.data.row_count);
                            vm.pageCount           = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage         = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading             = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchPaymentReport(obj) {
            let vm      = this;
            let url     = provider.baseURL + provider.getPaymentReport;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    po_number       : obj.po_number || '',
                    customer_id     : obj.customer_id || '',
                    supplier_id     : obj.supplier_id || '',
                    beeshop_id      : obj.beeshop_id || '',
                    type            : obj.type || '',
                    depot_id        : obj.depot_id || '',
                    collection_payment : obj.collection_payment || '',
                    product_type    : obj.product_type || '',
                    eco_business    : obj.eco_business || '',
                    search          : obj.search || '',
                    offset          : obj.offset - 1,
                    sort_by         : obj.sortBy || "created_at",
                    sort_desc       : obj.sortDesc === false ? 0 : 1,
                    limit           : obj.limit || vm.itemsPerPage,
                    from_date       : obj.from_date,
                    to_date         : obj.to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listPaymentReport            = res.data.row_count ? res.data.data : [];
                            vm.totalPage                    = parseInt(res.data.row_count);
                            vm.pageCount                    = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage                  = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading                      = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchSaleTransactionReport(obj) {
            let vm      = this;
            let url     = provider.baseURL + provider.getSaleTransaction;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    po_number       : obj.po_number || '',
                    customer_id     : obj.customer_id || '',
                    supplier_id     : obj.supplier_id || '',
                    provice_code    : obj.provice_code || '',
                    search          : obj.search || '',
                    offset          : obj.offset - 1,
                    sort_by         : obj.sortBy || "created_at",
                    sort_desc       : obj.sortDesc === false ? 0 : 1,
                    limit           : obj.limit || vm.itemsPerPage,
                    from_date       : obj.from_date,
                    to_date         : obj.to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listSaleTransactionReport    = res.data.row_count ? res.data.data : [];
                            vm.totalPage                    = parseInt(res.data.row_count);
                            vm.pageCount                    = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage                  = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading                      = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchStockBalanceReport(obj) {
            let vm      = this;
            let url     = provider.baseURL + provider.getStockBalance;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    customer_id     : obj.customer_id || '',
                    type            : obj.type || '',
                    depot_id        : obj.depot_id || '',
                    bo_id           : obj.bo_id || '',
                    product_id      : obj.product_id || '',
                    eco_business    : obj.eco_business || '',
                    transaction_type: obj.transaction_type || '',
                    product_type    : obj.product_type || '',
                    search          : obj.search || '',
                    offset          : obj.offset - 1,
                    sort_by         : obj.sortBy || "balance",
                    sort_desc       : obj.sortDesc === false ? 0 : 1,
                    limit           : obj.limit || vm.itemsPerPage,
                    from_date       : obj.from_date,
                    to_date         : obj.to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listStockBalanceReport    = res.data.row_count ? res.data.data : [];
                            vm.totalPage                    = parseInt(res.data.row_count);
                            vm.pageCount                    = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage                  = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading                      = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },

        fetchListPaymentVourcher({search, sortBy, sortDesc, offset, limit, id, from_date, to_date, type_order, contact_id, transaction_id}) {
            let vm      = this;
            let url     = provider.baseURL + provider.fetchListPaymentVourcher;
            vm.loading  = true;

            return new Promise((resolve, reject) => {
                axios.post(url, {
                    search          : search || "",
                    transaction_id  : transaction_id || "",
                    type_order      : type_order || "",
                    contact_id      : contact_id || "",
                    id              : id || "",
                    offset          : offset - 1,
                    sort_by         : sortBy || "created_at",
                    sort_desc       : sortDesc === false ? 0 : 1,
                    limit           : limit || vm.itemsPerPage,
                    from_date       : from_date,
                    to_date         : to_date
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.listPaymentVourcher  = res.data.data;
                            vm.totalPage            = parseInt(res.data.row_count);
                            vm.pageCount            = Math.ceil((vm.totalPage || 1) / vm.itemsPerPage);
                            vm.currentPage          = vm.pageCount < vm.currentPage ? vm.pageCount : vm.currentPage;
                            vm.loading              = false;
                        }
                    },
                    error => { reject(error); }
                );
            });
        },
    }
};
